// extracted by mini-css-extract-plugin
export default {"tabsContainer":"Tabs_tabsContainer__9y1XO","tab":"Tabs_tab__0AyCb","selectedTab":"Tabs_selectedTab__VIUoe"};